export const BRAINTREE_FRAME_ID = 'braintree-hosted-fields-frame';
export const FRAME_HEIGHT = 270;
